import { Messages } from 'lib/intl/messages';
import { messages as menuMessages } from './menu';
import { messages as settingsMessages } from './settings';
import { messages as actionsMessages } from './actions';
import { messages as statesMessages } from './states';
import { messages as authFormMessages } from './authForm';
import { messages as documentsMessages } from './documents';
import { messages as documentDetailMessages } from './documentDetail';
import { messages as invoiceDetailsMessages } from './invoiceDetails';
import { messages as release } from './release';
import { messages as featureRequest } from './featureRequest';
import { messages as releaseNotes } from './releaseNotes';

export const messages: Messages = {
  ...menuMessages,
  ...settingsMessages,
  ...actionsMessages,
  ...statesMessages,
  ...authFormMessages,
  ...documentsMessages,
  ...documentDetailMessages,
  ...invoiceDetailsMessages,
  ...release,
  ...featureRequest,
  ...releaseNotes,
};
